import { NotificationSeverity } from '../../controls/notifications/notifications.model';

export interface ResetPasswordNotification {
	notificationServiceSummary?: string;
	notificationServiceDetail?: string;
	notificationServiceSeverity: NotificationSeverity;
	customNotificationType?: CustomNotifications;
}

export enum CustomNotifications {
	COMPROMISED = 'COMPROMISED',
	CHECK_FAILED = 'CHECK_FAILED',
	SET_FAILED = 'SET_FAILED',
	CODE_SEND_FAILED = 'CODE_SEND_FAILED',
}

export class ResetPasswordNotifications {
	public static readonly ExposedPassword: ResetPasswordNotification = {
		notificationServiceSummary: 'Compromised password',
		notificationServiceDetail: null,
		notificationServiceSeverity: 'error',
		customNotificationType: CustomNotifications.COMPROMISED,
	};

	public static readonly FailedCheck: ResetPasswordNotification = {
		notificationServiceSummary: 'Verification failed',
		notificationServiceDetail: null,
		notificationServiceSeverity: 'error',
		customNotificationType: CustomNotifications.CHECK_FAILED,
	};

	public static readonly FailureToSet: ResetPasswordNotification = {
		notificationServiceSummary: 'Error',
		notificationServiceDetail: null,
		notificationServiceSeverity: 'error',
		customNotificationType: CustomNotifications.SET_FAILED,
	};

	public static readonly FailedCodeResend: ResetPasswordNotification = {
		notificationServiceSummary: 'Error',
		notificationServiceDetail: null,
		notificationServiceSeverity: 'error',
		customNotificationType: CustomNotifications.CODE_SEND_FAILED,
	};

	public static readonly SuccessfulReset: ResetPasswordNotification = {
		notificationServiceSummary: null,
		notificationServiceDetail: 'Password has been changed successfully. Redirecting to login page in 3 seconds',
		notificationServiceSeverity: 'success',
		customNotificationType: null,
	};

	public static readonly SuccessfulCodeResend: ResetPasswordNotification = {
		notificationServiceSummary: null,
		notificationServiceDetail: 'Verification code has been resent successfully.',
		notificationServiceSeverity: 'success',
		customNotificationType: null,
	};
}
